import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/pro-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import QuestionPreviewModal from '../../../../components/QuestionPreviewModal';
import {
  faMinus,
  faPlus,
  faChevronDown,
  faChevronRight,
  faXmark
} from '@fortawesome/free-solid-svg-icons';

import 'react-circular-progressbar/dist/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFerpaState,
  setFerpaState
} from '../../../../../../features/authentication/authSlice';
import Table from './components/Table';
import { useParams } from 'react-router-dom';
import {
  useGetSessionReportOptionsMutation,
  useGetStudentSessionReportMutation,
  useGetViewVocabularyMutation,
  useSetReportOptionsMutation,
  useGetVocabularyMutation,
  useGetQuestionAnswerResponseMutation,
  useGetVocabularyStudySheetMutation,
} from '../../../../../../features/authentication/reportApiSlice';
import Totals from './components/Totals';
import Modal from '../../../../../../components/Modal';
import {
  useGetFerpaStatusMutation,
  useShowIdentificationFieldsMutation
} from '../../../../../../features/authentication/assignApiSlice';
import Header from './components/Header';
import ReportOptions from './components/ReportOptions';
import {
  capitalizeFirstLetter,
  convertHtmlToPlainText,
  convertToCSV,
  mainTotalTable,
  mergeObjectsByNumber,
  mergeObjectsByNumberforExport,
  removePropertiesFromObjects,
  reorderObjectProperties,
  totalTableBasedOnIdividualQueston
} from '../../../../utils';
import CustomToast from '../../../../../../components/Toast';
import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import IndividualQuestionTableVertical from '../Reports/IndividualQuestionTableVertical';
import { useReportContext } from '../../../../../reports/components/reportContext';
import usePrintPdfGenerator from '../../../../../../utils/PrintPdfGenerator';
import PageSize from '../../../../../../enums/pageSize';
import ProgressButton from '../../../../../../components/ProgressButton';

const StudentInfo = () => {
  const [showReportOptions, setShowReportOptions] = React.useState(false);
  const [topicTableExpand, setTopicTableExpand] = React.useState(true);
  const [VocabularyExpand, setVocabularyExpand] = React.useState(false);
  const [tagTableExpand, setTagTableExpand] = React.useState(true);
  const [StandardTableExpand, setStandardTableExpand] = React.useState(true);
  const [ferpaEnabled, setFerpaEnabled] = React.useState(useSelector(selectFerpaState));
  const [levelTableExpand, setLevelTableExpand] = React.useState(true);
  const [courseTableExpand, setCourseTableExpand] = React.useState(true);
  const [attributeTableExpand, setAttributeTableExpand] = React.useState(true);
  const [changingReportOptions, setChangingReportOptions] = React.useState(false);
  const [showQuestionPreviewModal, setShowQuestionPreviewModal] = React.useState(false);
  const [creditName, setCreditName] = React.useState('No Credits');

  const [vocabularyData, setVocabularyData] = React.useState(null);
  const [vocabularyViewData, setVocabularyViewData] = React.useState(null);
  const [studentInfo, setStudentInfo] = React.useState(null);
  const [studentSessionReport, setStudentSessionReport] = React.useState(null);
  const [sessionReportOptions, setSessionReportOptions] = React.useState(null);
  const [vocabularyModalIsOpen, setVocabularyModalIsOpen] = React.useState(false);
  const [vocablurayModalName, setVocabularyModalName] = React.useState('');
  const [hideName, setHideName] = React.useState(false);
  const [answerModalOpen, setAnswerModalOpen] = React.useState(false);
  const [selectedAnswer, setSelectedAnswer] = React.useState(null);
  const [updatedData, setUpdatedData] = React.useState([]);
  const [questionAnwserResponse, setQuestionAnwserResponse] = React.useState(null);
  const [mainTotalTableData, setMainTotalTableData] = React.useState(null);
  const [copyData, setCopyData] = React.useState(null);
  const [selectedCreditId, setSelectedCreditId] = React.useState(null);
  const [vocabularySheetModalIsOpen, setVocabularySheetModalIsOpen] = React.useState(false);
  const [vocabularySheetData, setVocabularySheetData] = React.useState(null);
  const [questionId, setQuestionId] = React.useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [setReportOptions] = useSetReportOptionsMutation();
  const [getViewVocabulary] = useGetViewVocabularyMutation();
  const [getFerpaStatus] = useGetFerpaStatusMutation();
  const [getSessionReportOptions] = useGetSessionReportOptionsMutation();
  const [getStudentSessionReport] = useGetStudentSessionReportMutation();
  const [showIdentificationFields] = useShowIdentificationFieldsMutation();
  const [getQuestionAnswerResponse] = useGetQuestionAnswerResponseMutation();
  const [getVocabulary] = useGetVocabularyMutation();
  const [getVocabularyStudySheet] = useGetVocabularyStudySheetMutation();
  const { assignmentId, studentId, incompleteScoring } = useParams();
  const [dateTimeBasedUniqueKey, setDateTimeBasedUniqueKey] = React.useState(
    new Date().getTime().toString()
  );
  const reportContext = useReportContext();
  const { printPDF, isPdfGenerating } = usePrintPdfGenerator();
  const [isVocabularyPdfGenerating, setIsVocabularyPdfGenerating] = React.useState(false);

  React.useEffect(() => {
    if (assignmentId && studentId) {
      fetchStudentSessionReport();
      fetchSessionReportOptions();
    }
  }, [assignmentId]);

  React.useEffect(() => {
    fetchStudentName();
  }, [studentId]);

  React.useEffect(() => {
    getVocabluries();
  }, []);

  React.useEffect(() => {
    if (changingReportOptions) {
      optionReportHandler();
    }
    setSelectedCreditId(sessionReportOptions?.correctOnRetry);
  }, [sessionReportOptions]);

  React.useEffect(() => {
    let updatedQuestionProperties;
    if (studentSessionReport && sessionReportOptions) {
      // Make a copy of the array and update the inCorrect property for each topic
      updatedQuestionProperties = studentSessionReport.properties.questionProperties.map((item) => {
        const updatedTopics = item?.topics?.map((topic) => {
          return {
            ...topic,
            inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
              ? topic.inCorrect + topic.notAnswered
              : topic.inCorrect,
            crAnswered: sessionReportOptions.scoreUnscoredCRZero
              ? topic.crAnswered + topic.crNotAnswered
              : topic.crAnswered
          };
        });

        const updatedStandards = item?.standards?.map((standard) => ({
          ...standard,
          inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
            ? standard.inCorrect + standard.notAnswered
            : standard.inCorrect,
          crAnswered: sessionReportOptions.scoreUnscoredCRZero
            ? standard.crAnswered + standard.crNotAnswered
            : standard.crAnswered
        }));

        const updatedTags = item?.tags?.map((tag) => ({
          ...tag,
          inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
            ? tag.inCorrect + tag.notAnswered
            : tag.inCorrect,
          crAnswered: sessionReportOptions.scoreUnscoredCRZero
            ? tag.crAnswered + tag.crNotAnswered
            : tag.crAnswered
        }));

        const updatedLevels = item?.level?.map((level) => ({
          ...level,
          inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
            ? level.inCorrect + level.notAnswered
            : level.inCorrect,
          crAnswered: sessionReportOptions.scoreUnscoredCRZero
            ? level.crAnswered + level.crNotAnswered
            : level.crAnswered
        }));

        const updatedAttribute = item?.attribute?.map((attribute) => ({
          ...attribute,
          inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
            ? attribute.inCorrect + attribute.notAnswered
            : attribute.inCorrect,
          crAnswered: sessionReportOptions.scoreUnscoredCRZero
            ? attribute.crAnswered + attribute.crNotAnswered
            : attribute.crAnswered
        }));

        return {
          ...item,
          topics: updatedTopics,
          standards: updatedStandards,
          tags: updatedTags,
          level: updatedLevels,
          attribute: updatedAttribute,
          courseId: item.courseName == 'Teacher Questions - Short Answer ' ? -2 : item.courseId
        };
      });
      const questions = studentSessionReport.properties.questions.map((item) => ({
        ...item,
        inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
          ? item.inCorrect + item.notAnswered
          : item.inCorrect,
        crAnswered: sessionReportOptions.scoreUnscoredCRZero
          ? item.crAnswered + item.crNotAnswered
          : item.crAnswered
      }));
      updatedQuestionProperties[0].questions = questions;
      const value = totalTableBasedOnIdividualQueston(studentSessionReport, sessionReportOptions);

      const updatedData = updatedQuestionProperties?.map((course) => {
        if (course.courseName === 'Teacher Questions - Short Answer ') {
          return {
            ...course,
            totals: value.teacherQuestionReport
          };
        } else if (course.courseName !== 'Teacher Questions - Multiple Choice ') {
          return {
            ...course,
            totals: value.courseReport
          };
        }
      });
      setCopyData(updatedData);
    }
  }, [studentSessionReport, sessionReportOptions]);

  useEffect(() => {
    const totalTableData = mainTotalTable(
      studentSessionReport,
      sessionReportOptions,
      selectedCreditId
    );
    setMainTotalTableData(totalTableData);
  }, [studentSessionReport, sessionReportOptions]);

  const fetchSessionReportOptions = async () => {
    const option = {
      assignmentId: assignmentId,
      studentId: studentId
    };
    try {
      const response = await getSessionReportOptions(option).unwrap();
      setSessionReportOptions(response);
      allCredits.map((item) => {
        if (item.id === response.correctOnRetry) {
          setCreditName(item.name);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const downloadCSV = (csvData) => {
    if (csvData) {
      let csvContent = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
      const link = document.createElement('a');
      link.href = csvContent;
      link.download = 'AssignmentCumulativeReport.csv';
      link.click();
    }
  };

  const fetchStudentSessionReport = async () => {
    const option = {
      assignmentId: assignmentId,
      studentId: studentId,
      incompleteScoring: incompleteScoring
    };
    try {
      let response = await getStudentSessionReport(option).unwrap();
      const updatedResponse = {...response,studentResults :[response.studentResult]};
      setStudentSessionReport(updatedResponse);
      setStudentInfo(response);
    } catch (error) {
      CustomToast(error.data, 'error');
      navigate(-1);
    }
  };

  const allCredits = [
    {
      id: 1,
      name: 'No Credits'
    },
    {
      id: 2,
      name: 'Half Credits'
    },
    {
      id: 3,
      name: 'Full Credits'
    }
  ];

  const checkBoxInput = [
    {
      id: 'displayNotStartedStudents',
      label: 'Display students who have not started the assignment',
      checked: sessionReportOptions?.displayNotStartedStudents,
      toolTip:
        'When checked all students will display regardless of if they started the assignment, but results will not be scored unless you check options below.'
    },
    {
      id: 'scoreNotStarted',
      label: 'Score assignments that have not been started',
      checked: sessionReportOptions?.scoreNotStarted,
      toolTip: 'Any assignments that have not been started will be scored as 0.'
    },
    {
      id: 'scoreStartedNotCompletedIncorrect',
      label: 'Score assignments that have been started but not completed',
      checked: sessionReportOptions?.scoreStartedNotCompletedIncorrect,
      toolTip:
        'Any incomplete questions on assignments that have been started will be calculated as incorrect.'
    },
    {
      id: 'scoreUnscoredCRZero',
      label: 'Score un-scored CR questions as 0 points',
      checked: sessionReportOptions?.scoreUnscoredCRZero,
      toolTip:
        'Any un-scored constructed response question will be scored as 0, regardless of if the student answered it.'
    }
  ];

  const includeReportCheckBox = [
    [
      {
        id: 'totals',
        label: 'Totals',
        checked: sessionReportOptions?.totals
      },
      {
        id: 'correctIncorrectRetry',
        label: 'Correct/Incorrect',
        checked: sessionReportOptions?.correctIncorrectRetry
      },
      {
        id: 'standards',
        label: 'Standards',
        checked: sessionReportOptions?.standards
      },
      {
        id: 'units',
        label: 'Topics',
        checked: sessionReportOptions?.units
      }
    ],
    [
      {
        id: 'themes',
        label: 'Tags',
        checked: sessionReportOptions?.themes
      },
      {
        id: 'levels',
        label: 'Levels',
        checked: sessionReportOptions?.levels
      },
      {
        id: 'attributes',
        label: 'Attributes',
        checked: sessionReportOptions?.attributes
      }
    ]
  ];

  const handleCheckBonInput = (id) => {
    setChangingReportOptions(true);
    const updatedSessionReportOptions = {
      ...sessionReportOptions,
      [id]: !sessionReportOptions[id]
    };
    setSessionReportOptions(updatedSessionReportOptions);
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const optionReportHandler = async () => {
    const option = [
      {
        passingScore: sessionReportOptions.passingScore,
        correctOnRetry: sessionReportOptions.correctOnRetry,
        displayNotStartedStudents: sessionReportOptions.displayNotStartedStudents,
        scoreNotStarted: sessionReportOptions.scoreNotStarted,
        scoreStartedNotCompletedIncorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect,
        scoreUnscoredCRZero: sessionReportOptions.scoreUnscoredCRZero,
        totals: sessionReportOptions.totals,
        correctIncorrectRetry: sessionReportOptions.correctIncorrectRetry,
        standards: sessionReportOptions.standards,
        units: sessionReportOptions.units,
        themes: sessionReportOptions.themes,
        levels: sessionReportOptions.levels,
        attributes: sessionReportOptions.attributes
      },
      {
        reportOptionType: null
      }
    ];

    try {
      setReportOptions(option).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const reportChangeHandler = (id) => {
    setChangingReportOptions(true);
    const updatedSessionReportOptions = {
      ...sessionReportOptions,
      [id]: !sessionReportOptions[id]
    };
    setSessionReportOptions(updatedSessionReportOptions);
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const handleFerpaChange = async (e) => {
    dispatch(
      setFerpaState({
        ferpaEnabled: e.target.checked ? e.target.checked : !ferpaEnabled
      })
    );
    const data = {
      condition: e.target.checked ? e.target.checked : !ferpaEnabled
    };
    setFerpaEnabled(!ferpaEnabled);
    try {
      await showIdentificationFields(data).unwrap();
      await fetchStudentName();
    } catch (error) {
      console.log(error);
    }
  };

  const additionOptionInputValueHandler = (value, option) => {
    const parsedValue = parseInt(value);
    if (value !== '' && (!Number.isInteger(parsedValue) || parsedValue < 0 || parsedValue > 99)) {
      // If the value is not empty and not an integer within the range (0 to 99), return early without updating state.
      return;
    }
    setChangingReportOptions(true);
    const updatedSessionReportOptions = {
      ...sessionReportOptions,
      [option]: value === '' ? '' : parsedValue
    };
    setSessionReportOptions(updatedSessionReportOptions);
  };

  const handlePrint = async () => {
    if(isPdfGenerating) return;

    setShowReportOptions(true);

    const contentWrapper = document.getElementById('session_pdf_Wrapper');
    const htmlString = contentWrapper.innerHTML;

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const svgElements = tempContainer.querySelectorAll('svg');

    svgElements.forEach((svgElement) => {
      if (svgElement.classList.contains('fa-circle-question')) {
        svgElement.classList.add('d-none');
      } else if (svgElement.classList.contains('svg-inline--fa')) {
        svgElement.classList.remove('fa-check');
        svgElement.classList.remove('fa-xmark');
        svgElement.style.width = '10px';
      }
    });

    const selects = tempContainer.querySelectorAll('select');
    selects.forEach((select) => {
      select.style.backgroundImage = 'none';
      select.style.width = '200px';
    });

    const reportOptionsDiv = tempContainer.querySelector('#reportOptionsDiv');
    if (reportOptionsDiv) {
      reportOptionsDiv.classList.add('d-none');
    }

    const vacabulary_study_sheetDiv = tempContainer.querySelector('#vacabulary_study_sheetDiv');
    if (vacabulary_study_sheetDiv) {
      vacabulary_study_sheetDiv.classList.add('d-none');
    }

    const checkBoxs = tempContainer.querySelectorAll('input.form-check-input');
    checkBoxs.forEach((checkBox) => {
      checkBox.style.backgroundImage = '';
      checkBox.style.color = '#525252';
    });

    const buttonElements = tempContainer.querySelectorAll('button');
    buttonElements.forEach((svgElement) => {
      svgElement.classList.add('d-none');
    });

    const creditDropDownSelect = tempContainer.querySelector('#creditDropDown');
    if (creditDropDownSelect) {
      creditDropDownSelect.classList.add('d-none');
    }

    const creditNameTextBox = tempContainer.querySelector('#creditNameTextBox');
    if (creditNameTextBox) {
      if (creditNameTextBox.classList.contains('d-none')) {
        creditNameTextBox.classList.remove('d-none');
      }
    }

    await printPDF('SessionReport', tempContainer.innerHTML, PageSize.A3);
  };

  const vocabularyPrintToPdf = async () => {
    if(isVocabularyPdfGenerating) return;

    setIsVocabularyPdfGenerating(true);
    const options = {
      margin: 60,
      filename: 'VocabularyStudySheet.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }
    };
    const contentWrapper = document.getElementById('vocabularSheet');
    const contentClone = contentWrapper.cloneNode(true);

    const printButton = contentClone.querySelector('#printButton');
    printButton.style.display = 'none';

    const svgElements = contentClone.querySelectorAll('svg.svg-inline--fa');
    svgElements.forEach((svgElement) => {
      svgElement.classList.add('d-none');
    });

    await html2pdf().set(options).from(contentClone).save('VocabularyStudySheet.pdf');
    setIsVocabularyPdfGenerating(false);
  };

  const getVocabularyDetails = async (value) => {
    const option = {
      id: value.vocabularyId,
      courseId: value.courseId
    };
    setVocabularyModalName(value.vocabularyName);
    try {
      const response = await getViewVocabulary(option).unwrap();
      setVocabularyData(response);
      setVocabularyModalIsOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const getVocabluries = async () => {
    setVocabularyExpand(!VocabularyExpand);
    if (!vocabularyViewData) {
      const option = {
        assignmentId: assignmentId,
        studentId: studentId
      };
      try {
        const response = await getVocabulary(option).unwrap();
        setVocabularyViewData(response);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const toggleHideName = async () => {
    const data = {
      condition: hideName
    };
    try {
      await showIdentificationFields(data).unwrap();
      await fetchStudentName();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchStudentName = async () => {
    const data = {
      studentId: studentId
    };
    const response = await getFerpaStatus(data).unwrap();
    if (!response?.showIdentificationFields) {
      setHideName(true);
      setFerpaEnabled(false);
    } else {
      setFerpaEnabled(true);
      setHideName(false);
    }
  };

  const exportHandler = async () => {
    let newUpdatedData = [...copyData];
    if (copyData.length > 1) {
      newUpdatedData.forEach((item) => {
        item.topics = mergeObjectsByNumber(
          item.topics,
          selectedCreditId,
          'topics',
          sessionReportOptions
        );
        item.standards = mergeObjectsByNumber(
          item.standards,
          selectedCreditId,
          'standards',
          sessionReportOptions
        );
        item.tags = mergeObjectsByNumber(item.tags, selectedCreditId, 'tags', sessionReportOptions);
        item.level = mergeObjectsByNumber(
          item.level,
          selectedCreditId,
          'level',
          sessionReportOptions
        );
        item.attribute = mergeObjectsByNumber(
          item.attribute,
          selectedCreditId,
          'attribute',
          sessionReportOptions
        );
        item.totals = mergeObjectsByNumberforExport(
          item.totals,
          selectedCreditId,
          'totals',
          sessionReportOptions
        );
      });
    } else {
      newUpdatedData.forEach((item) => {
        item.topics = mergeObjectsByNumber(
          item.topics,
          selectedCreditId,
          'topics',
          sessionReportOptions
        );
        item.standards = mergeObjectsByNumber(
          item.standards,
          selectedCreditId,
          'standards',
          sessionReportOptions
        );
        item.tags = mergeObjectsByNumber(item.tags, selectedCreditId, 'tags', sessionReportOptions);
        item.level = mergeObjectsByNumber(
          item.level,
          selectedCreditId,
          'level',
          sessionReportOptions
        );
        item.attribute = mergeObjectsByNumber(
          item.attribute,
          selectedCreditId,
          'attribute',
          sessionReportOptions
        );
        item.totals = mergeObjectsByNumberforExport(
          item.totals,
          selectedCreditId,
          'totals',
          sessionReportOptions
        );
      });
    }
    let data;
    let newData;

    if (copyData.length > 1) {
      data = removePropertiesFromObjects(newUpdatedData);
      for (const key in data) {
        for (const mainKey in data[key]) {
          if (data[key][mainKey].hasOwnProperty(mainKey)) {
            const mainValue = data[key][mainKey];

            for (const item of mainValue[mainKey]) {
              const capitalizedKey = capitalizeFirstLetter(mainKey);
              if (item.score) {
                item.score = typeof item.score === 'number' ? Math.round(item.score) : item.score;
              }
              if (capitalizedKey === 'Standards') {
                item[capitalizedKey] = `${item.description}:${item.standardNumber}`;
                delete item.standardNumber;
              }
              if (capitalizedKey === 'Totals') {
                item[capitalizedKey] = '';
              } else {
                if (capitalizedKey === 'Topics') {
                  const descriptionString = convertHtmlToPlainText(item.description);
                  // Replace multiple spaces with a single space
                  item[capitalizedKey] = descriptionString.replace(/\s+/g, ' ');
                  delete item.description;
                } else {
                  item[capitalizedKey] = item.description;
                  delete item.description;
                }
              }
            }
          }
        }
      }

      newData = [data[0], data[1]];
    } else {
      data = removePropertiesFromObjects(newUpdatedData);

      for (const key in data) {
        for (const mainKey in data[key]) {
          if (data[key][mainKey].hasOwnProperty(mainKey)) {
            const mainValue = data[key][mainKey];
            for (const item of mainValue[mainKey]) {
              const capitalizedKey = capitalizeFirstLetter(mainKey);
              if (item.score) {
                item.score = typeof item.score === 'number' ? Math.round(item.score) : item.score;
              }
              if (capitalizedKey === 'Standards') {
                item[capitalizedKey] = `${item.description}:${item.standardNumber}`;
                delete item.standardNumber;
              }
              if (capitalizedKey === 'Topics') {
                const descriptionString = convertHtmlToPlainText(item.description);
                // Replace multiple spaces with a single space
                item[capitalizedKey] = descriptionString.replace(/\s+/g, ' ');
                delete item.description;
              } else {
                item[capitalizedKey] = item.description;
                delete item.description;
              }
            }
          }
        }
      }

      newData = { ...data };
    }

    const tableElement = document.getElementById('individualQuestion');

    const jsonData = [];
    const headerCells = tableElement.querySelectorAll('tr.table-head th.text-center');

    const bodyRows = tableElement.querySelectorAll('tr.table-body');
    bodyRows.forEach((row) => {
      const rowData = {};

      // Loop through each cell in the row
      const cells = row.querySelectorAll('td.text-center');
      cells.forEach((cell, index) => {
        const header = headerCells[index].innerText.trim();
        const value = cell.innerText.trim();
        rowData[header] = value;
      });

      jsonData.push(rowData);
    });

    // Add new properties to the new object
    const newObjectWithNewProperties = {
      // Assignment: studentSessionReport?.sessionReportInfo?.Assignment || 'Assignment Name',
      'Assignment Mode': studentSessionReport?.assignmentMode,
      Assignment: studentSessionReport?.session,
      Course: studentSessionReport?.course,
      'Correct on Retry': creditName,
      Teacher: studentSessionReport?.teacher,
      Student: hideName ? 'name hidden' : studentSessionReport?.studentName,
      'Completion Date': studentSessionReport?.completionDate,
      'Report Date': studentSessionReport?.reportDate
    };

    const modifiedData = jsonData.map((item, index) => {
      let modifiedAnswers = item.Answers;
      if (typeof item.Answers === 'string' && /^\[\d+\]$/.test(item.Answers)) {
        modifiedAnswers = item.Answers.slice(1, -1); // Remove square brackets
      }

      return {
        Question: 'Q' + (index + 1),
        Answers: modifiedAnswers
      };
    });

    const answers = {};
    modifiedData.forEach((result) => {
      let answerKey;
      switch (result.Answers) {
      case 'Correct':
        answerKey = 'C';
        break;
      case 'Incorrect':
        answerKey = 'C';
        break;
      case 'Correct on Retry':
        answerKey = 'R';
        break;
      default:
        answerKey = result.Answers; // Handle other cases if needed
        break;
      }
      answers[result.Question] = answerKey;
    });

    const individualResults = [
      {
        Name: hideName ? 'name hidden' : studentSessionReport?.studentName,
        'Student ID': hideName ? 'ID hidden' : studentSessionReport?.studentResult?.identification,
        Score:
          typeof mainTotalTableData.totals?.score === 'number'
            ? Math.round(mainTotalTableData.totals?.score)
            : mainTotalTableData.totals?.score,
        ...answers
      }
    ];

    let updatedArrayForCsv;

    if (copyData.length > 1) {
      updatedArrayForCsv = {
        Totals: [
          {
            score: mainTotalTableData.totals?.score,
            correct: mainTotalTableData.totals?.correct,
            incorrect: mainTotalTableData.totals?.inCorrect,
            correctOnRetry: mainTotalTableData.totals?.correctOnRetry,
            crAnswered: mainTotalTableData.totals?.crAnswered
          }
        ]
      };
      newData.map((item, index) => {
        const { attribute, level, standards, tags, topics, ...dataObject } = item;
        updatedArrayForCsv[item.courseName] = {
          Totals: item.totals,
          'By Topics': topics,
          'By Tags': tags,
          'By Difficulty Level': level,
          'By Attribute': attribute,
          'By Standard': standards
        };
      });
    } else {
      const { attribute, level, standards, tags, topics, ...dataObject } = newData[0];
      updatedArrayForCsv = {
        Totals: [
          {
            score: mainTotalTableData.totals?.score,
            correct: mainTotalTableData.totals?.correct,
            incorrect: mainTotalTableData.totals?.inCorrect,
            correctOnRetry: mainTotalTableData.totals?.correctOnRetry,
            crAnswered: mainTotalTableData.totals?.crAnswered
          }
        ],
        'By Topics': topics,
        'By Tags': tags,
        'By Difficulty Level': level,
        'By Attribute': attribute,
        'By Standard': standards
      };
    }

    if (copyData.length > 1) {
      for (const key in updatedArrayForCsv) {
        if (updatedArrayForCsv.hasOwnProperty(key)) {
          const value = updatedArrayForCsv[key];
          if (!sessionReportOptions?.units) {
            delete value['By Topics'];
          }
          if (!sessionReportOptions?.levels) {
            delete value['By Difficulty Level'];
          }

          if (!sessionReportOptions?.attributes) {
            delete value['By Attribute'];
          }

          if (!sessionReportOptions?.standards) {
            delete value['By Standard'];
          }

          if (!sessionReportOptions?.themes) {
            delete value['By Tags'];
          }
        }
      }
    } else {
      if (!sessionReportOptions?.units) {
        delete updatedArrayForCsv['By Topics'];
      }

      if (!sessionReportOptions?.levels) {
        delete updatedArrayForCsv['By Difficulty Level'];
      }

      if (!sessionReportOptions?.attributes) {
        delete updatedArrayForCsv['By Attribute'];
      }

      if (!sessionReportOptions?.standards) {
        delete updatedArrayForCsv['By Standard'];
      }

      if (!sessionReportOptions?.themes) {
        delete updatedArrayForCsv['By Tags'];
      }
    }

    updatedArrayForCsv.ReportOptions = newObjectWithNewProperties;
    updatedArrayForCsv.IndividualQuestionResult = individualResults;
    const footerMessage = `\n\nQuestions marked as R (Correct On Retry) are counted as ${
      creditName == 'No Credits'
        ? 'incorrect'
        : creditName === 'Half Credits'
          ? 'Half Credit'
          : 'Full Credit'
    }  in the scoring.`;
    const newDataWithReportOptionsFirst = reorderObjectProperties(
      updatedArrayForCsv,
      'ReportOptions'
    );
    const csvData = convertToCSV(newDataWithReportOptionsFirst, footerMessage);
    downloadCSV(csvData, 'SessionStudentReport');
  };

  const questionPreviewHandler = async (questionId) => {
    setQuestionId(questionId),
    setShowQuestionPreviewModal(!showQuestionPreviewModal);
  };

  const handleSelectCredits = async (e) => {
    allCredits.map((credit) => {
      if (credit.id == e.target.value) {
        setCreditName(credit.name);
      }
    });
    setChangingReportOptions(true);
    setSelectedCreditId(e.target.value);
    const updateData = {
      ...sessionReportOptions,
      correctOnRetry: parseInt(e.target.value)
    };
    setSessionReportOptions(updateData);
  };

  const answerModalHandler = async (result) => {
    if (result.status === 'Not Answered') return;
    setQuestionAnwserResponse(null);
    setAnswerModalOpen(!answerModalOpen);
    const options = {
      questionId: result.questionId,
      sessionId: studentSessionReport?.studentResult.sessionId,
      courseId: result.courseId
    };

    try {
      const response = await getQuestionAnswerResponse(options).unwrap();
      setQuestionAnwserResponse(response);
    } catch (error) {
      console.log(error);
    }
    setSelectedAnswer(result);
  };

  const getVocabularySheetDetails = async () => {
    setVocabularySheetData(null);
    const option = {
      assignmentId: assignmentId,
      studentId: studentId
    };

    try {
      setVocabularySheetModalIsOpen(true);
      const response = await getVocabularyStudySheet(option).unwrap();
      setVocabularySheetData(response);
    } catch (error) {
      console.log(error);
    }
  };

  return studentInfo ? (
    <>
      <div className="white-card" id="session_pdf_Wrapper">
        <Header
          exportHandler={exportHandler}
          handlePrint={handlePrint}
          handleFerpaChange={(e) => handleFerpaChange(e)}
          ferpaEnabled={ferpaEnabled}
          toggleHideName={toggleHideName}
          studentInfo={studentInfo}
          setExpand={setShowReportOptions}
          expand={showReportOptions}
          hideName={hideName}
          setHideName={setHideName}
          title= {reportContext?.isAssessment ? 'Student- Single Assessment Report' : 'Student- Single Assignment Report'}
          allCredits={allCredits}
          selectedCreditId={selectedCreditId}
          creditName={creditName}
          sessionReportOptions={sessionReportOptions}
          isPdfGenerating={isPdfGenerating}
          showRetryInfo={true}
        />

        <div className="mt-5 d-flex justify-content-between">
          <div className="d-flex">
            <div className="indicator-blue"></div>
            <p className="mx-1">{`>= ${sessionReportOptions?.passingScore}%`} </p>
            <div className="indicator-red mx-1"></div>
            <p className="mx-1">{`< ${sessionReportOptions?.passingScore}%`}</p>
          </div>
          <div id="reportOptionsDiv" className="d-flex align-item-center report-button" style={{ cursor: 'pointer' }} onClick={() => setShowReportOptions(!showReportOptions)}>
            Report Options
            {
              <div style={{ marginLeft: '0.5em' }}>
                <FontAwesomeIcon icon={showReportOptions ? faMinus : faPlus} />
              </div>
            }
          </div>
        </div>

        <ReportOptions
          key={dateTimeBasedUniqueKey}
          expand={showReportOptions}
          sessionReportOptions={sessionReportOptions}
          additionOptionInputValueHandler={additionOptionInputValueHandler}
          handleCheckBonInput={handleCheckBonInput}
          checkBoxInput={checkBoxInput}
          includeReportCheckBox={includeReportCheckBox}
          reportChangeHandler={reportChangeHandler}
          allCredits={allCredits}
          handleSelectCredits={handleSelectCredits}
          selectedCreditId={selectedCreditId}
          creditName={creditName}
          showRetryOptions={true}
        />

        {sessionReportOptions.totals && studentSessionReport.properties && (
          <Totals
            studentSessionReport={studentSessionReport}
            sessionReportOptions={sessionReportOptions}
            details={mainTotalTableData}
          />
        )}
        {copyData?.map((item, index) => {
          return (
            <>
              {copyData.length > 1 && (
                <>
                  <p
                    className="p-3 mt-3"
                    style={{
                      background: '#f0f2f8'
                    }}>
                    <strong>{item?.courseName}</strong>
                  </p>
                  {sessionReportOptions.totals && (
                    <Table
                      index={index}
                      courseName={item?.courseName}
                      setExpand={setCourseTableExpand}
                      expand={courseTableExpand}
                      tittle="Totals"
                      setUpdatedData={setUpdatedData}
                      titleName="totals"
                      details={item.totals}
                      selectedCreditId={selectedCreditId}
                      sessionReportOptions={sessionReportOptions}
                      initialData={copyData}
                    />
                  )}
                </>
              )}

              <div className="mb-5">
                {sessionReportOptions?.units && item?.topics && (
                  <Table
                    index={index}
                    courseName={item?.courseName}
                    tittle="By Topics"
                    setExpand={setTopicTableExpand}
                    expand={topicTableExpand}
                    setUpdatedData={setUpdatedData}
                    details={item?.topics}
                    selectedCreditId={selectedCreditId}
                    sessionReportOptions={sessionReportOptions}
                    initialData={copyData}
                    titleName="topics"
                  />
                )}
                {sessionReportOptions?.themes && item?.tags && (
                  <Table
                    index={index}
                    courseName={item?.courseName}
                    tittle="By Tags"
                    setExpand={setTagTableExpand}
                    expand={tagTableExpand}
                    details={item?.tags}
                    selectedCreditId={selectedCreditId}
                    sessionReportOptions={sessionReportOptions}
                    setUpdatedData={setUpdatedData}
                    initialData={copyData}
                    titleName="tags"
                  />
                )}
                {sessionReportOptions?.levels && item?.level && (
                  <Table
                    index={index}
                    courseName={item?.courseName}
                    tittle="By Difficulty Level"
                    setExpand={setLevelTableExpand}
                    expand={levelTableExpand}
                    details={item?.level}
                    selectedCreditId={selectedCreditId}
                    sessionReportOptions={sessionReportOptions}
                    setUpdatedData={setUpdatedData}
                    initialData={copyData}
                    titleName="level"
                  />
                )}
                {sessionReportOptions?.attributes && item?.attribute && (
                  <Table
                    index={index}
                    courseName={item?.courseName}
                    tittle="By Attributes"
                    setExpand={setAttributeTableExpand}
                    expand={attributeTableExpand}
                    details={item?.attribute}
                    selectedCreditId={selectedCreditId}
                    sessionReportOptions={sessionReportOptions}
                    setUpdatedData={setUpdatedData}
                    initialData={copyData}
                    titleName="attribute"
                  />
                )}
                {sessionReportOptions?.standards && item?.standards && (
                  <Table
                    index={index}
                    courseName={item?.courseName}
                    tittle="By Standard"
                    setExpand={setStandardTableExpand}
                    expand={StandardTableExpand}
                    details={item?.standards}
                    standard={true}
                    selectedCreditId={selectedCreditId}
                    sessionReportOptions={sessionReportOptions}
                    setUpdatedData={setUpdatedData}
                    initialData={copyData}
                    titleName="standards"
                  />
                )}
              </div>
            </>
          );
        })}
        
        {studentSessionReport &&
          <IndividualQuestionTableVertical
            details={studentSessionReport} 
            sessionReportOptions={sessionReportOptions} 
            ferpaEnabled={ferpaEnabled} 
            retryScoringOptionId={selectedCreditId}
            mainTotalTableData={mainTotalTableData} />
        }

        <div className="mt-5">
          <div className="d-flex justify-content-between">
            <p className="table_tittle">Vocabulary Related To Incorrect Questions</p>
            <button
              style={{
                background: '#e1eeff',
                color: 'rgba(84, 113, 200, 0.6)',
                width: '30px',
                height: '30px',
                textAlign: 'center',
                border: 'none',
                marginLeft: '10px'
              }}
              className="rounded-circle"
              onClick={getVocabluries}>
              {VocabularyExpand ? (
                <FontAwesomeIcon icon={faChevronDown} />
              ) : (
                <FontAwesomeIcon icon={faChevronRight} />
              )}
            </button>
          </div>
          {VocabularyExpand && vocabularyViewData && (
            <div className="d-flex">
              <div style={{ width: '75%' }} className="d-flex flex-wrap">
                {vocabularyViewData?.map((item, index) => (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => getVocabularyDetails(item)}
                    key={index}
                    className="p-2 text-decoration-underline"
                    dangerouslySetInnerHTML={{ __html: item.vocabularyName }}></div>
                ))}
              </div>
              <div
                className="vacabulary_study_sheet"
                id="vacabulary_study_sheetDiv"
                style={{ cursor: 'pointer' }}
                onClick={() => getVocabularySheetDetails()}>
                <FontAwesomeIcon color="#F7931E" icon={faBook} />
                <h3>Vocabulary Study Sheet</h3>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="student_response_header d-flex justify-content-end gap-3 mt-4">
        <button onClick={exportHandler} className="btn btn-castleWhite">
          Export
        </button>
        <button
          onClick={handlePrint}
          id="print_button"
          className={`btn btn-castleRed ${isPdfGenerating ? 'disabled' : ''}`}>
          {isPdfGenerating ? 'Generating PDF...' : 'Print to PDF'}
        </button>
      </div>

      <Modal
        titleName={'Vocabulary Study Sheet'}
        hideHeader={true}
        isOpen={vocabularySheetModalIsOpen}
        contentWidth={'90%'}
        onClose={() => setVocabularySheetModalIsOpen(false)}>
        <div id="vocabularSheet" className="mx-3 my-4">
          <div className="modal-header-in">
            <div className=" w-100 d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex gap-2">
                <h3 className="primary-title mb-0 fw-bold">{'Vocabulary Study Sheet'}</h3>
              </div>
              <FontAwesomeIcon
                className="ms-2"
                size="5x"
                icon={faXmark}
                onClick={() => setVocabularySheetModalIsOpen(false)}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div>
                  <strong>Name: </strong>
                  {!ferpaEnabled ? 'name hidden' : studentSessionReport?.studentResult?.name}
                </div>
                <div>
                  <strong>Course: </strong>
                  {studentInfo?.course}
                </div>
              </div>
              <div className="text-center mx-5">
                <ProgressButton
                  isLoading={isVocabularyPdfGenerating}
                  onClick={vocabularyPrintToPdf}
                  loadingLabel="Generating PDF"
                  label="Print to PDF"
                  className="btn btn-castleRed"
                  expectedDuration={1500}
                />
              </div>
            </div>
          </div>
          <div className="my-3">
            {vocabularySheetData == null ? (
              <>
                <div className="fw-bold">
                  <Skeleton />{' '}
                </div>
                <div className="fw-bold">
                  <Skeleton />{' '}
                </div>
                <div className="fw-bold">
                  <Skeleton />{' '}
                </div>
                <div className="fw-bold">
                  <Skeleton />{' '}
                </div>
                <div className="fw-bold">
                  <Skeleton />{' '}
                </div>
                <div className="fw-bold">
                  <Skeleton />{' '}
                </div>
              </>
            ) : (
              <>
                {vocabularySheetData?.vocabularies?.map((item, index) => (
                  <>
                    <div className="fw-bold">{item.name}</div>
                    <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
                  </>
                ))}
              </>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        titleName={vocablurayModalName}
        isOpen={vocabularyModalIsOpen}
        onClose={() => setVocabularyModalIsOpen(false)}>
        <div dangerouslySetInnerHTML={{ __html: vocabularyData?.description }}></div>
      </Modal>

      <Modal
        titleName={'Student Reponse to question'}
        isOpen={answerModalOpen}
        contentWidth={'65%'}
        onClose={() => setAnswerModalOpen(false)}>
        {questionAnwserResponse ? (
          <div>
            {selectedAnswer?.status === 'Correct' && (
              <>
                <table>
                  <tr>
                    <td>Status : </td>
                    <td>{questionAnwserResponse?.status}</td>
                  </tr>
                  <tr>
                    <td>Correct Answer : </td>
                    <td>{questionAnwserResponse?.correctAnswer}</td>
                  </tr>
                  <tr>
                    <td>Question Id : </td>
                    <td>{questionAnwserResponse?.questionId}</td>
                  </tr>
                </table>
              </>
            )}

            {(selectedAnswer?.status === 'Incorrect' ||
              selectedAnswer?.status === 'Correct on Retry') && (
              <>
                <table>
                  <tr>
                    <td>Status : </td>
                    <td>{questionAnwserResponse?.status}</td>
                  </tr>
                  <tr>
                    <td>Correct Answer : </td>
                    <td>{questionAnwserResponse?.correctAnswer}</td>
                  </tr>
                  <tr>
                    <td>Question Id : </td>
                    <td>{questionAnwserResponse?.questionId}</td>
                  </tr>
                  <tr>
                    <td>Student Response : </td>
                    <td>{questionAnwserResponse?.studentAnswer}</td>
                  </tr>
                  <tr>
                    <td>Student Retry Response : </td>
                    <td>{questionAnwserResponse?.studentRetryResponse}</td>
                  </tr>
                </table>
              </>
            )}

            {selectedAnswer?.crStatus?.status === 'Answered' && (
              <>
                <table>
                  <tr>
                    <td>Status : </td>
                    <td>{questionAnwserResponse?.status}</td>
                  </tr>
                  <tr>
                    <td>Sample Answer : </td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.sampleAnswer
                      }}></td>
                  </tr>
                  <tr>
                    <td>Student Answer : </td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.studentAnswer
                      }}></td>
                  </tr>
                </table>
              </>
            )}
            {selectedAnswer?.crStatus?.status === 'Not Answered' && (
              <>
                <table>
                  <tr>
                    <td>Status : </td>
                    <td>{questionAnwserResponse?.status}</td>
                  </tr>
                  <tr>
                    <td>Sample Answer : </td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.sampleAnswer
                      }}></td>
                  </tr>
                </table>
              </>
            )}
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '40px' }}>
            <HesSpinner />
            <span className="ms-3">Loading results...</span>
          </div>
        )}
      </Modal>

      <QuestionPreviewModal
        isOpen={showQuestionPreviewModal}
        onClose={() => setShowQuestionPreviewModal(false)}
        questionId={questionId}
        assignmentId={parseInt(assignmentId)}
        isPublicAssignment={false}
      />
    </>
  ) : (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
      <HesSpinner />
      <span className="ms-3">Loading results...</span>
    </div>
  );
};

export default React.memo(StudentInfo);
